import { types } from './appActions';

const INITIAL_STATE = {
  messageDataList: [],
  reloadPopup: {
    open: false,
    version: null,
  },
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.APP_ADD_MESSAGE:
      return {
        ...state,
        messageDataList: [...state.messageDataList, action.payload]
      };
    case types.APP_REMOVE_MESSAGE:
      return {
        ...state,
        messageDataList: state.messageDataList.filter(
          item => item.timestamp !== action.payload.timestamp
        )
      };
    case types.APP_SHOW_SNACKBAR:
      return { ...state };
    case types.SET_RELOAD_POPUP:
      return {
        ...state,
        reloadPopup: {
          open: action.payload.open,
          version: action.payload.version,
        },
      };
    default:
      return state;
  }
};